/**
 * Implements a Trending line in header
 * Data located in useTrending.ts
 */
import TrendingCoin from './TrendingCoin';
import { ITrendingItem } from '@kattana-io/common';
import { IStore } from '../../reducers';
import { useSelector } from 'react-redux';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import flash from '../../assets/images/flash.svg';
import './styles.scss';

const Trending = () => {
  const { items, isError, loading } = useSelector((state: IStore) => state.trendingReducer);

  if (loading) {
    return (<div className="trending">
      <div className="trending__loading">
        <Text size={14} className="text--grey-400">Loading...</Text>
      </div>
    </div>);
  }

  if (!loading && !isError) {
    return (
      <div className="trending">
        <div className="trending__icon">
          <Image src={flash} size='m' />
        </div>
        <div className='trending__visibility trending--flex'>
          <div className="trending__items">
            {items.map((item: ITrendingItem) => <TrendingCoin key={item.id} item={item} />)}
          </div>
        </div>
      </div>
    );
  }
  // return nothing if error
  return null;
};

export default Trending;